import request from '@/utils/request'

// 查询系列列表
export function listSeries(query) {
  return request({
    url: '/biz/admin/goods/series/list',
    method: 'get',
    params: query
  })
}

// 查询全部系列（可按品牌过滤）
export function allSeries(query) {
  return request({
    url: '/biz/admin/goods/series/all',
    method: 'get',
    params: query
  })
}

export function merchantSeries(data) {
  return request({
    url: '/biz/admin/goods/series/merchant/list',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: data
  })
}

// 查询系列分页
export function pageSeries(query) {
  return request({
    url: '/biz/admin/goods/series/page',
    method: 'get',
    params: query
  })
}

// 查询系列详细
export function getSeries(data) {
  return request({
    url: '/biz/admin/goods/series/detail',
    method: 'get',
    params: data
  })
}

// 新增系列
export function addSeries(data) {
  return request({
    url: '/biz/admin/goods/series/add',
    method: 'post',
    data: data
  })
}

// 修改系列
export function updateSeries(data) {
  return request({
    url: '/biz/admin/goods/series/edit',
    method: 'post',
    data: data
  })
}

// 删除系列
export function delSeries(data) {
  return request({
    url: '/biz/admin/goods/series/delete',
    method: 'post',
    data: data
  })
}
